<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/profile'" :linkttitle="'返回'" title=""></PageHeader>
        <b-container class="bg-white p-3 p-md-5 mt-5 mt-sm-2 shadow-sm rounded ">

            <b-form style="width: 400px" class="mx-auto">
                <h3 class="text-center mb-5">更改密碼</h3>
                <b-form-group

                        label="舊密碼"

                        description=""
                >
                    <b-form-input
                            maxlength="12"
                            v-model="formData.confirmpw"
                            type="password"
                            required
                            @change="checkvalue('confirmpw')"
                            placeholder="輸入您的舊密碼"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="formData.confirmpwcheck">
                        {{ formData.confirmpwmsg }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group

                        label="新密碼"

                        description=""
                >
                    <b-form-input
                            maxlength="12"
                            v-model="formData.password"
                            type="password"
                            required
                            @change="checkvalue('password')"
                            placeholder="輸入您的新密碼"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="formData.passwordcheck">
                        {{ formData.passwordmsg }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group

                        label="再次輸入密碼"

                        description=""
                >
                    <b-form-input
                            maxlength="12"
                            v-model="formData.repassword"
                            type="password"
                            required
                            @change="checkvalue('repassword')"
                            placeholder="再次輸入你的新密碼"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="formData.repasswordcheck">
                        {{ formData.repasswordmsg }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-alert
                        :show="dismissCountDown"
                        dismissible
                        variant="warning"
                        @dismissed="dismissCountDown=0"
                        @dismiss-count-down="countDownChanged"
                >
                    {{ alrtmsg }}
                </b-alert>
                <b-overlay
                        :show="sendloading"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="primary"
                        class=" mt-3"

                >
                <b-button pill class="mt-3" variant="primary ActionBtnBg" block @click="SendMail">確定更改密碼</b-button>
                </b-overlay>

            </b-form>
        </b-container>


    </div>


</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import {toastsModel, alertModel } from '@/service/commuse'

export default {
  name: 'login',
  components: {Nav,PageHeader},
  data () {
    return {
      formData: {
        confirmpw: '',
        confirmpwcheck: null,
        confirmpwmsg: '',
        password: '',
        passwordcheck: null,
        passwordmsg: '',
        repassword: '',
        repasswordcheck: null,
        repasswordmsg: '',
        remember: false
      },
      sendloading:false,
      dismissCountDown:0,
      alrtmsg:''
    }
  },
  computed: {},
  methods: {
    checkvalue (way) {
      switch (way) {
        case 'confirmpw':
          if (this.formData.confirmpw.length == 0) {
            this.formData.confirmpwcheck = false
            this.formData.confirmpwmsg = '請填寫您的舊密碼'
          } else {
            this.formData.confirmpwcheck = true
            this.formData.confirmpwmsg = ''
          }
          break
        case 'password':

          let isPwd = /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/;
          let Password = this.formData.password
          if (Password.length < 6 || Password.length > 12 || !isPwd.test(Password)) {
            this.formData.passwordcheck = false
            this.formData.passwordmsg = '登錄密碼必須6-12位，包含數字+字母組合!'
          }else{
            this.formData.passwordcheck = true
          }

          break
        case 'repassword':
          if (this.formData.repassword.length == 0) {
            this.formData.repasswordcheck = false
            this.formData.repasswordmsg = '不能為空'
          }else{
            if(this.formData.password !== this.formData.repassword){
              this.formData.repasswordcheck = false
              this.formData.repasswordmsg = '新密碼驗證錯誤，請再次檢查'
            }else{
              this.formData.repasswordcheck = true
              this.formData.repasswordmsg = ''
            }
          }

          break
      }

    },
    SendMail () {








      this.checkvalue('confirmpw')
      this.checkvalue('password')
      this.checkvalue('repassword')
      if(
        this.formData.confirmpwcheck == true &&
        this.formData.passwordcheck == true &&
        this.formData.repasswordcheck == true
      ){
        this.sendloading = true
        this.$store.dispatch('actionChangeMemPwd', {
          oldpassword:this.formData.confirmpw,
          newpassword:this.formData.password,
          renewpassword:this.formData.repassword
        }).then((res) => {
          this.sendloading = false

          alertModel(this,"系統訊息","更改成功").then(()=>{
            this.$router.push('/profile');
          })





        }).catch((res) => {
          this.sendloading = false
          this.alrtmsg = '更改失敗，請確認密碼是否正確'
          this.showAlert()

        })

      }


    },
    countDownChanged(dismissCountDown){
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = 5
    }
  }
}
</script>
